<!-- <div class="profile-container">
  <div class="card-top profile-header">
    <div class="profile-image">
      <img [src]="profile.imageUrl" alt="Profile Image" class="img">
    </div>
  </div>
  <div class="edit">
    <button (click)="editProfile()" class="btn-edit">
      <span >
        <fa-icon [icon]="['fas', 'pen']" class="fa-pen" ></fa-icon>
      </span>
    </button>
  </div>
  <div class="profile-info">
    <div class="info-row">
      <div class="info-item">
        <label>UserName</label>
        <span>{{ profile.username }}</span>
      </div>
      <div class="info-item">
        <label>Email</label>
        <span>{{ profile.email }}</span>
      </div>
    </div>
    <div class="info-row">
      <div class="info-item">
        <label>Profile Name</label>
        <span>{{ profile.first_name }} {{ profile.last_name}}</span>
      </div>
      <div class="info-item">
        <label>Role</label>
        <span>{{ profile.role }}</span>
      </div>
    </div>
    
  </div>
</div> -->



  <div>
   

    <!-- Main Content -->
    <div class="main-content">
      <header class="top-header">
          <h3>Profile Info</h3>
      </header>

      <div class="profile-info" *ngIf="canEditProfile">
          <input
            #fileInput
            type="file"
            (change)="onFileSelected($event)"
            accept="image/jpeg,image/png,image/gif,image/webp"
            style="display: none;"
            
          />
          <img class="profile-img" [src]="profile.imageUrl" alt="profile image">
          <div class="camera-overlay" (click)="fileInput.click()">
            <fa-icon [icon]="['fas', 'camera']"></fa-icon>
          </div>
        <div class="profile-details">
          <h3>{{profile.username}}</h3>
          <p>{{profile.email}}</p>
        </div>
      </div> 
      <form class="form" [formGroup]="profileForm" (ngSubmit)="saveProfile()" *ngIf="canEditProfile">
        <div class="form-row">
          <div class="form-group">
            <label>First Name <small>*</small></label>
            <input type="text" placeholder="Your First Name" formControlName="firstName">
            <div  class="error" *ngIf="profileForm.get('firstName')?.invalid && profileForm.get('firstName')?.touched">
              <small *ngIf="profileForm.get('firstName')?.errors?.['required']">First Name is required.</small>
            </div>
          </div>
          <div class="form-group">
            <label>Last Name</label>
            <input type="text" placeholder="Your Last Name" formControlName="lastName">
          </div>
          <!-- <div class="form-group" *ngIf="!isAdmin">
            <label>Role <small>*</small></label>
            <input id="role"  formControlName="role" readonly>
            <div  class="error" *ngIf="profileForm.get('role')?.invalid && profileForm.get('role')?.touched">
              <small *ngIf="profileForm.get('role')?.errors?.['required']">Role is required.</small>
            </div>
          </div> -->
          <div class="form-group">
            <label for="role">Role <small>*</small></label>
            <input *ngIf="!canEditRole" id="role" [value]="editableRoleLabel" readonly />
            <select *ngIf="canEditRole" formControlName="role" id="role" >
              <option *ngFor="let option of role | keyvalue" [value]="option.value">{{ option.value }}</option>
            </select>
            <div  class="error" *ngIf="profileForm.get('role')?.invalid && profileForm.get('role')?.touched">
              <small *ngIf="profileForm.get('role')?.errors?.['required']">Role is required.</small>
            </div>
          </div>
          <div class="form-group">
            <label>Created Date  <small>*</small></label>
            <input type="text" placeholder="Created Date" [value]="profile.date_joined | date: 'dd/MM/yyyy'" readonly>
          </div>
          <div class="form-group">
            <label>Organization  <small>*</small></label>
            <input id="organization"  formControlName="organization" readonly />
              <small class="org-assigned-hint">Assigned automatically</small>
          </div>
          <!-- <div class="form-group">
            <label>Created Date  <small>*</small></label>
            <span>{{profile.date_joined | date: 'dd/MM/yyyy'}}</span>
          </div>
          <div class="form-group">
            <label>Organization  <small>*</small></label>
            <span>{{profile.organization}}</span>
          </div> -->
          <div class="form-group">
            <label>Mobile Number <small>*</small></label>
            <div class="input-container">
              <input id="mobileNumber" formControlName="mobileNumber">
              <!-- <fa-icon *ngIf="isMobileVerified && !mobileChanged"  [icon]="['fas', 'circle-check']" class="verify-icon"></fa-icon> -->
            </div>
            <div  class="error" *ngIf="profileForm.get('mobileNumber')?.invalid && profileForm.get('mobileNumber')?.touched">
              <small *ngIf="profileForm.get('mobileNumber')?.errors?.['required']">Mobile Number is required.</small>
            </div>
            <!-- <button *ngIf="mobileChanged" type="button" class="btn-verify" (click)="sendOTP()">
              <fa-icon [icon]="['fas', 'circle-check']" class="fa-thin"></fa-icon> VERIFY
            </button> -->
          </div>
        </div>
        <div class="button-row">
          <button class="btn-save" type="submit" [disabled]="!formChanged">
            <fa-icon [icon]="['fas', 'square-plus']" style="padding-right: 3px;" ></fa-icon>
            Update</button>
          <button type="button" class="btn-cancel" (click)="onCancel()">
            <fa-icon [icon]="['fas', 'square-xmark']" class="fa-thin"></fa-icon> CANCEL
          </button>
          
        </div>
      </form>
      <div class="profile-info" *ngIf="!canEditProfile">
          
        <img class="profile-img" [src]="profile.imageUrl" alt="profile image">
        <div class="profile-details">
          <h3>{{profile.username}}</h3>
          <p>{{profile.email}}</p>
        </div>
    </div> 
    <form class="form" [formGroup]="profileForm" (ngSubmit)="saveProfile()" *ngIf="!canEditProfile">
        <div class="form-row">
          <div class="form-group">
            <label>First Name <small>*</small></label>
            <!-- <input type="text" placeholder="Your First Name" formControlName="firstName"> -->
             <span>{{profile.first_name}}</span>

          </div>
          <div class="form-group">
            <label>Last Name</label>
             <span>{{profile.last_name}}</span>
          </div>
          <div class="form-group">
            <label for="role">Role <small>*</small></label>
            <span>{{ displayRole }}</span>

            <!-- <select formControlName="role" id="role" >
              <option *ngFor="let option of role | keyvalue" [value]="option.value">{{ option.value }}</option>
            </select> -->
            
          </div>
          <div class="form-group">
            <label>Created Date  <small>*</small></label>
            <span>{{profile.date_joined | date: 'dd/MM/yyyy'}}</span>
          </div>
          <div class="form-group">
            <label>Organization  <small>*</small></label>
            <span>{{profile.organization}}</span>
          </div>
          <div class="form-group">
            <label>Mobile Number <small>*</small></label>
            <span>{{profile.mobile_number}}</span>
          </div>
        </div>
        <!-- <div class="button-row">
          <button class="btn-save" type="submit" [disabled]="!formChanged">
            <fa-icon [icon]="['fas', 'square-plus']" style="padding-right: 3px;" ></fa-icon>
            Update</button>
          <button type="button" class="btn-cancel" (click)="onCancel()">
            <fa-icon [icon]="['fas', 'square-xmark']" class="fa-thin"></fa-icon> CANCEL
          </button>
          
        </div> -->
    </form>
    </div>
  </div>

<div *ngIf="showConfirmationDialog" class="confirmation-modal">
   <div class="public-container">
      <!-- Main Content -->
      <div class="main-content">
        <!-- <fa-icon [icon]="['fas', 'circle-xmark']" class="close-modal"></fa-icon> -->
        <div class="close">
          <span  (click)="closeConfirmationDialog()">
            <fa-icon [icon]="['fas', 'circle-xmark']"></fa-icon>
          </span>
        </div>
         <div class="fp-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 16 16"><path fill="currentColor" d="M11.5 0h-7C3.675 0 3 .675 3 1.5v13c0 .825.675 1.5 1.5 1.5h7c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5M6 .75h4v.5H6zM8 15a1 1 0 1 1 0-2a1 1 0 0 1 0 2m4-3H4V2h8z"/></svg>
         </div>
         <div class="header-content-fp">
            <h4>Mobile Phone Verification</h4>
            <p>Please enter the verification code we just sent to your WhatsApp number
                 {{mobileNumber}}.</p>
         </div>
         
         <form class="form" [formGroup]="otpForm" (ngSubmit)="verifyOTP()">
            <div class="form-row">
               <div class="otp-box-group">
                  <input
                      *ngFor="let ctrl of otpControls; let i = index"
                      type="text"
                      maxlength="1"
                      pattern="[0-9]*"
                      inputmode="numeric"
                      class="otp-box"
                      [formControl]="ctrl"
                      (input)="onOtpInput($event, i)"
                      (keydown)="onOtpKeyDown($event, i)"
                      autocomplete="one-time-code"
                  />
               </div>
               <div *ngIf="error" class="error">{{ error }}</div>
            </div>
            
            <div class="btn-submit">
                <button type="submit" [disabled]="isSubmitting || otpForm.invalid">Verify OTP</button>
            </div>
           
            <div class="back-login">
                <p *ngIf="timer > 0">Verification code expires in <span class="text-pink-600 font-semibold">{{ timer }}</span> seconds</p><br>
                <p>Didn't receive the code?
                <a (click)="sendOTP()"><strong>Resend</strong></a></p>
            </div>
         </form>
      </div>
   </div>
</div>
